module.exports = __webpack_public_path__ + "img/5f_r_musashi.a5eb8c47.png";